var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('v-flex',{attrs:{"xs11":"","md6":"","lg4":""}},[_c('login-form')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }